// utils/csrfToken.js
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

let csrfToken = null;

export const getCsrfToken = async () => {
  if (csrfToken) return csrfToken;
  
  try {
    const response = await fetch(`${API_URL}/api/csrf-token`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' }
    });
    
    if (!response.ok) throw new Error('Failed to get CSRF token');
    
    const data = await response.json();
    csrfToken = data.token;
    return csrfToken;
  } catch (err) {
    console.error('CSRF token fetch failed:', err);
    throw new Error('Security check failed. Please refresh the page.');
  }
};

export const resetCsrfToken = () => {
  csrfToken = null;
};
